import React from "react";
import "./attendantDashboard.css"

export default function FollowerDashBoard(){
    console.log("follower dashboard")
    return(
        <React.Fragment>
        
        </React.Fragment>
    )
}